{
    "nav": {
        "home": "Přehled",
        "requests": "Žádosti",
        "family": "Moje rodina",
        "menu": "Menu",
        "settings": "Nastavení",
        "contactUs": "Kontakt",
        "signOut": "Odhlásit se"
    },
    "screens": {
        "leaveRequest": "Omluvenka",
        "medicalRequest": "Zdravotní poznámka",
        "pickupRequest": "Žádost o vyzvednutí",
        "absences": "Absence",
        "pickups": "Vyzvednutí",
        "leaveDays": "Dny bez vyzvedávání",
        "selectOption": "Vyberte možnost"
    },
    "login": {
        "welcome": "Vítejte v BASIS Prague",
        "continueWithSchool": "Pokračujte pomocí školního účtu",
        "signInFailed": "Přihlášení se nezdařilo",
        "unknownError": "Neznámá chyba",
        "unlocking": "Odemykání…",
        "unlockWith": "Odemknout pomocí {{method}}",
        "signingIn": "Přihlašování…",
        "signInWithSchool": "Přihlásit se školním účtem",
        "microsoft": {
            "errors": {
                "canceled": "Přihlášení Microsoft bylo zrušeno.",
                "not-completed": "Přihlášení Microsoft nebylo dokončeno.",
                "no-id-token": "Přihlášení Microsoft selhalo. Chybí Token ID."
            }
        },
        "getTheAppOnYourPhone": "Stáhněte aplikaci pro svůj telefon",
        "downloadOnTheAppStore": "Stáhnout z App Store",
        "getItOnGooglePlay": "Stáhnout z Google Play"
    },
    "home": {
        "title": "Přehled",
        "requestsTitle": "Rychlé žádosti",
        "requestsDescription": "Vytvořte omluvenku, zdravotní poznámku nebo žádost o vyzvednutí.",
        "requestLeave": "Omluvenka",
        "requestMedical": "Zdravotní",
        "requestPickup": "Vyzvednutí",
        "medicalNoteCount": "Zdravotní poznámka",
        "medicalNotesCount": "Zdravotní poznámky",
        "pickupCount": "Vyzvednutí",
        "pickupsCount": "Vyzvednutí",
        "walksHome": "Odchází sám ve dnech: {{days}}",
        "pickupRequiredAlways": "Nutné vyzvednutí každý den",
        "pickupChange": "Změna vyzvednutí",
        "pickupRowSubtitle": "{{date}} · {{picker}}",
        "pickupRecurringRowSubtitle": "{{days}} · {{from}} – {{to}} · {{picker}}",
        "noStudents": "K vašemu účtu není registrován žádný student.",
        "students": "Studenti",
        "student": "Student",
        "studentsDescription": "Otevřete omluvenky nebo žádosti o vyzvednutí pro studenta.",
        "leaveRequests": "Omluvenky",
        "leaveNeedsAction": "Vyžaduje doplnění",
        "pickupRequests": "Vyzvednutí",
        "viewAbsences": "Zobrazit omluvenky",
        "viewAbsencesA11y": "{{name}}, zobrazit omluvenky",
        "viewPickupA11y": "{{name}}, zobrazit vyzvednutí",
        "viewAbsencesNeedsInfoA11y": "{{name}}, škola žádá o doplnění informací k omluvence"
    },
    "medical": {
        "selectStudent": "Pro pokračování vyberte studenta",
        "noteHint": "Sdílejte se školou dočasnou zdravotní poznámku o dítěti. Je oddělená od trvalých zdravotních údajů v profilu.",
        "notePlaceholder": "např. rekonvalescence, dočasné léky, omezení aktivit…",
        "noteRequired": "Zadejte zdravotní poznámku.",
        "submit": "Odeslat poznámku",
        "submitting": "Odesílám…",
        "save": "Uložit změny",
        "saving": "Ukládám…",
        "edit": "Upravit",
        "expandA11y": "{{name}}, rozbalit zdravotní poznámku",
        "expandA11yNoName": "Rozbalit zdravotní poznámku",
        "revoke": "Odvolat",
        "revoking": "Odvolávám…",
        "revokeConfirmTitle": "Odvolat zdravotní poznámku",
        "revokeConfirmMessage": "Škola už tuto dočasnou poznámku neuvidí.",
        "revokeConfirmKeep": "Ponechat",
        "errorTitle": "Chyba",
        "submittedTitle": "Poznámka odeslána",
        "submittedBody": "Zdravotní poznámka pro {{name}} byla sdílena se školou.",
        "submitFailed": "Zdravotní poznámku se nepodařilo odeslat. Zkuste to znovu.",
        "updatedTitle": "Poznámka upravena",
        "updatedBody": "Zdravotní poznámka pro {{name}} byla aktualizována.",
        "updateFailed": "Zdravotní poznámku se nepodařilo upravit. Zkuste to znovu.",
        "revokedTitle": "Poznámka odvolána",
        "revokedBody": "Zdravotní poznámka byla odvolána.",
        "revokeFailed": "Zdravotní poznámku se nepodařilo odvolat."
    },
    "pickup": {
        "formHint": "Recepce školy dostane informaci, kdo dítě vyzvedne. Další schválení není potřeba.",
        "date": "Datum vyzvednutí",
        "startDate": "Začátek",
        "endDate": "Konec",
        "endDateOptional": "Bez konce",
        "days": "Dny",
        "everyDay": "Každý den",
        "selectedDays": "Vybrané dny",
        "studentsRequired": "Pro vytvoření žádosti o vyzvednutí vyberte alespoň jednoho studenta.",
        "dateRequired": "Vyberte datum vyzvednutí, ať recepce ví, kdy dítě čekat.",
        "endDateRequired": "Vyberte, kdy má týdenní vyzvedávání skončit.",
        "endBeforeStart": "Poslední vyzvednutí by mělo být ve stejný den nebo později než první. Upravte prosím data.",
        "daysRequired": "Vyberte aspoň jeden den v týdnu.",
        "pickerName": "Vyzvedávající osoba",
        "pickerNamePlaceholder": "Celé jméno",
        "pickerNameRequired": "Doplňte jméno osoby, která dítě vyzvedne.",
        "relationship": "Vztah ke studentovi",
        "relationshipPlaceholder": "např. babička, rodinný přítel…",
        "relationshipRequired": "Napište, jaký má tato osoba ke studentovi vztah.",
        "note": "Poznámka",
        "notePlaceholder": "Cokoli, co by recepce měla vědět…",
        "submit": "Oznámit recepci",
        "submitting": "Odesílám…",
        "expandA11yNoName": "Rozbalit vyzvednutí {{date}} osobou {{picker}}",
        "expandA11yRecurringNoName": "Rozbalit týdenní vyzvednutí {{days}} od {{from}} do {{to}} osobou {{picker}}",
        "revoke": "Odvolat",
        "revoking": "Odvolávám…",
        "revokeConfirmTitle": "Odvolat vyzvednutí",
        "revokeConfirmMessage": "Recepce bude informována o odvolání vyzvednutí.",
        "revokeConfirmKeep": "Ponechat",
        "errorTitle": "Ještě jeden detail",
        "submittedTitle": "Vyzvednutí odesláno",
        "submittedBody": "Recepce byla informována o vyzvednutí studenta {{name}}.",
        "submitFailed": "Oznámení se teď nepodařilo odeslat. Zkuste to znovu.",
        "revokedTitle": "Vyzvednutí odvoláno",
        "revokedBody": "Informace o vyzvednutí byla odvolána.",
        "revokeFailed": "Odvolání se teď nepodařilo. Zkuste to znovu.",
        "recurringWeekdays": "Opakovaně: {{days}}"
    },
    "requests": {
        "title": "Žádosti",
        "actionNeededTitle": "Vyžadována akce",
        "periodRange": "{{from}} – {{to}}",
        "periodCurrentRange": "Aktuální · {{range}}",
        "periodToday": "Dnes",
        "periodPreviousA11y": "Předchozí období",
        "periodNextA11y": "Následující období",
        "periodTodayA11y": "Zobrazit aktuální období",
        "emptyPeriod": "V tomto období nejsou žádné omluvenky.",
        "awaitingSchoolTitle": "Čekání na potvrzení",
        "filterAllStudents": "Všichni studenti"
    },
    "family": {
        "title": "Moje rodina",
        "subtitle": "Seznam osob propojených s vaším školním účtem."
    },
    "menu": {
        "settings": "Nastavení",
        "contactUs": "Kontakt",
        "signOut": "Odhlásit se",
        "title": "Menu"
    },
    "settings": {
        "security": "Zabezpečení",
        "requireUnlock": "Vyžadovat {{method}} k odemčení",
        "biometricSystemDisabled": "{{method}} je v nastavení systému vypnuté. Zapněte jej pro lepší zabezpečení aplikace.",
        "biometricOpenSettingsTitle": "{{method}} je vypnuté",
        "biometricOpenSettingsMessage": "Povolte {{method}} pro tuto aplikaci v nastavení systému, abyste mohli používat odemykání aplikace.",
        "version": "Verze {{version}}",
        "activeSessions": "Vaše zařízení",
        "copyrightRights": "Všechna práva vyhrazena.",
        "copyright": "© {{year}} BASIS Educational Group CZ, s.r.o.",
        "notifications": {
            "title": "Oznámení",
            "push": "Zasílat oznámení na toto zařízení",
            "systemDisabled": "Oznámení jsou v nastavení systému vypnutá. Zapněte je tam, abyste dostávali upozornění ze školy.",
            "openSettingsTitle": "Oznámení jsou vypnutá",
            "openSettingsMessage": "Povolte oznámení pro tuto aplikaci v nastavení systému, abyste dostávali upozornění.",
            "openSettings": "Otevřít nastavení"
        },
        "display": {
            "title": "Zobrazení",
            "theme": "Vzhled",
            "themeFooter": "Vyberte světlý, tmavý vzhled, nebo ponechte automatický vzhled podle nastavení systému.",
            "theme-light": "Světlý",
            "theme-dark": "Tmavý",
            "theme-system": "Automatický",
            "language": "Jazyk aplikace",
            "languageFooter": "Jazyk aplikace. Můžete jej změnit i v <settingsLink>Nastavení</settingsLink> na svém zařízení pro tuto aplikaci.",
            "languageFooterWeb": "Výchozí jazyk prohlížeče lze změnit v nastavení prohlížeče.",
            "language-en": "English",
            "language-cs": "Čeština",
            "language-system": "Systém (výchozí)",
            "language-browser": "Prohlížeč (výchozí)"
        }
    },
    "activeSessions": {
        "title": "Vaše zařízení",
        "description": "Tato zařízení a prohlížeče jsou v tuto chvíli přihlášena do vašeho účtu. Odhlaste se z jakéhokoli, které již nepotřebujete.",
        "sectionTitle": "Kde jste přihlášeni",
        "empty": "Žádná aktivní zařízení.",
        "loadError": "Aktivní zařízení se nepodařilo načíst.",
        "tryAgain": "Zkusit znovu",
        "thisDevice": "Toto zařízení",
        "signOut": "Odhlásit",
        "signingOut": "Odhlašování…",
        "signOutAll": "Odhlásit ze všech zařízení",
        "lastActive": "Naposledy aktivní {{relative}}",
        "lastActiveRecently": "Naposledy aktivní nedávno",
        "device": {
            "webBrowser": "Webový prohlížeč",
            "iphone": "iPhone",
            "android": "Zařízení Android",
            "mobileApp": "Mobilní aplikace",
            "unknown": "Neznámé zařízení"
        },
        "revokeCurrentTitle": "Odhlásit toto zařízení ?",
        "revokeCurrentMessage": "Budete odhlášeni z aplikace na tomto zařízení.",
        "revokeOtherTitle": "Odhlásit toto přihlášení ?",
        "revokeOtherMessage": "Tím se ukončí přihlášení na zařízení „{{device}}“.",
        "revokeAllTitle": "Odhlásit ze všech zařízení ?",
        "revokeAllMessage": "Budete odhlášeni ze všech zařízení a prohlížečů včetně tohoto.",
        "revokeFailedTitle": "Odhlášení se nezdařilo",
        "revokeAllFailedTitle": "Odhlášení ze všech zařízení se nezdařilo",
        "revokeFailedFallback": "Zkuste to prosím znovu."
    },
    "contact": {
        "general": "Obecné",
        "ourCampuses": "Naše kampusy",
        "officeHours": "Úřední hodiny: {{hours}}",
        "website": "Webová stránka",
        "campusAccessibilityLabel": "Kampus {{name}}"
    },
    "leave": {
        "student": {
            "noStudents": "Není propojen žádný student.",
            "label": "Student",
            "labelMultiple": "Studenti"
        },
        "reasons": {
            "family_emergency": "Rodinná událost",
            "holiday": "Dovolená",
            "illness": "Nemoc",
            "medical_appointment": "Lékařská prohlídka",
            "visa_residency_appointment": "Vízum / pobyt",
            "extracurricular": "Mimoškolní aktivita"
        },
        "reasonDescriptions": {
            "family_emergency": "Omluvenka nejvýše na jeden den.",
            "holiday": "Vícedenní omluvenka.",
            "illness": "Část dne nebo déle. Může být bez data konce.",
            "medical_appointment": "Omluvenka nejvýše na jeden den.",
            "visa_residency_appointment": "Omluvenka nejvýše na jeden den.",
            "extracurricular": "Část dne nebo déle. Může se opakovat."
        },
        "status": {
            "pending": "Čeká na schválení",
            "approved": "Schváleno",
            "conditionally_approved": "Podmíněně schváleno",
            "rejected": "Zamítnuto",
            "cancelled": "Zrušeno",
            "needs_info": "Vyžaduje doplnění"
        },
        "selectReasonPlaceholder": "Vyberte důvod",
        "selectReason": "Vyberte důvod omluvenky",
        "reason": "Důvod",
        "close": "Zavřít",
        "viewRequestA11y": "Zobrazit omluvenku: {{reason}}, {{status}}, {{dates}}",
        "viewRequestA11yWithChild": "{{name}}, zobrazit omluvenku: {{reason}}, {{status}}, {{dates}}",
        "selectReasonA11y": "Vyberte důvod omluvenky",
        "closeReasonPickerA11y": "Zavřít výběr důvodu",
        "start": "Začátek",
        "when": "Kdy",
        "partOfDayStart": "Od",
        "partOfDayEnd": "Do",
        "end": "Konec",
        "allDay": "Celodenní",
        "absent": "Nepřítomnost",
        "arrivesAt": "Přijde později",
        "leavesAt": "Odchází dříve",
        "partOfDay": "Jiný čas",
        "recurringEnd": "Opakovat do",
        "leavesAtTime": "Odchází v {{time}}",
        "arrivesAtTime": "Přijde v {{time}}",
        "weeklyOn": "Každý týden ({{days}})",
        "timeRequired": "Vyberte čas, nebo zvolte Celodenní.",
        "timeOrder": "Čas od musí být dříve než čas do.",
        "timeToRequiresDateTo": "Čas do lze nastavit jen když je vyplněné datum do.",
        "fromTime": "od {{time}}",
        "untilTime": "do {{time}}",
        "endDateRequired": "Vyberte prosím datum ukončení.",
        "endDateOptional": "Bez konce",
        "ongoing": "Probíhá",
        "notSet": "Není nastaveno",
        "daysRequired": "Vyberte alespoň jeden den v týdnu pro pravidelnou omluvenku.",
        "additionalInformation": "Doplňující informace",
        "additionalInformationPlaceholder": "Doplňující informace pro školu…",
        "submit": "Odeslat žádost",
        "submitting": "Odesílání…",
        "errorTitle": "Chyba",
        "startDateRequired": "Vyberte prosím datum začátku.",
        "dateOutsideSchoolYear": "Vybraná data musí být v aktuálním školním roce ({{from}} – {{to}}).",
        "submittedTitle": "Omluvenka odeslána",
        "submittedBody": "Omluvenka pro {{name}} byla odeslána škole.",
        "submittedMixedBody": "Omluvenka pro {{approvedNames}} byla automaticky schválena. Omluvenka pro {{pendingNames}} byla odeslána škole.",
        "autoApprovedTitle": "Omluvenka schválena",
        "autoApprovedBody": "Omluvenka pro {{name}} byla automaticky schválena. Škola byla informována.",
        "submitFailed": "Omluvenku se nepodařilo odeslat. Zkuste to prosím znovu.",
        "events": {
            "created": "Odesláno",
            "auto_approved": "Automaticky schváleno",
            "cancelled": "Zrušeno",
            "approved": "Schváleno",
            "conditionally_approved": "Podmíněně schváleno",
            "rejected": "Zamítnuto",
            "info_requested": "Vyžádány informace",
            "resubmitted": "Znovu odesláno",
            "attachment_added": "Přidána příloha",
            "attachment_removed": "Odebrána příloha",
            "end_date_set": "Datum ukončení nastaveno",
            "status_changed": "Stav změněn"
        },
        "history": "Historie",
        "actionNeeded": "Vyžadována akce",
        "schoolRequestTitle": "Zpráva od školy",
        "infoRequestedDefault": "Škola požádala o doplňující informace, než bude možné žádost posoudit.",
        "resubmitHint": "Doplňte poznámku a/nebo nahrajte dokument a poté žádost znovu odešlete.",
        "resubmitPlaceholder": "Doplňte požadované informace",
        "addInformation": "Doplnit informace",
        "resubmit": "Znovu odeslat ke schválení",
        "closeResubmitA11y": "Zavřít formulář pro znovuodeslání",
        "resubmitting": "Odesílání…",
        "cancelRequest": "Zrušit žádost",
        "cancelling": "Rušení…",
        "cancelConfirmTitle": "Zrušit žádost",
        "cancelConfirmMessage": "Opravdu chcete zrušit tuto omluvenku?",
        "cancelConfirmKeep": "Ponechat",
        "cancelledTitle": "Zrušeno",
        "cancelledBody": "Omluvenka byla zrušena.",
        "cancelFailed": "Omluvenku se nepodařilo zrušit.",
        "resubmittedTitle": "Znovu odesláno",
        "resubmittedBody": "Omluvenka byla znovu odeslána ke schválení.",
        "resubmitFailed": "Omluvenku se nepodařilo znovu odeslat.",
        "setEndDate": "Nastavit datum ukončení",
        "changeEndDate": "Změnit datum ukončení",
        "saveEndDate": "Uložit datum ukončení",
        "savingEndDate": "Ukládání…",
        "closeUpdateEndDateA11y": "Zavřít formulář pro nastavení data konce",
        "endDateBeforeStart": "Datum ukončení nesmí být dříve než datum začátku.",
        "endDateUpdatedTitle": "Datum ukončení uloženo",
        "endDateUpdatedBody": "Datum ukončení bylo uloženo.",
        "updateEndDateFailed": "Datum ukončení se nepodařilo uložit.",
        "submittedAt": "Odesláno {{date}}",
        "updatedAt": "Aktualizováno {{date}}",
        "attachments": {
            "label": "Přílohy s dokumenty pro školu",
            "hint": "Přidejte soubory PDF nebo obrázky (max. 5 souborů, 10 MB)",
            "add": "Přidat přílohu",
            "addMenuHint": "Přidat ze souboru nebo galerie.",
            "pickFile": "Vybrat soubor",
            "pickGallery": "Vybrat obrázek z galerie",
            "working": "Aktualizace příloh…",
            "unsupportedType": "Nepodporovaný typ souboru. Použijte PDF, JPG, PNG nebo WEBP.",
            "tooLarge": "Každá příloha může mít nejvýše 10 MB.",
            "uploadFailed": "Přílohu se nepodařilo nahrát.",
            "uploadAfterCreateFailed": "Omluvenka byla vytvořena, ale některé přílohy se nepodařilo nahrát.",
            "remove": "Odebrat",
            "removeConfirmTitle": "Odebrat přílohu",
            "removeConfirmMessage": "Odebrat {{name}} z této omluvenky?",
            "removedTitle": "Příloha odebrána",
            "removedBody": "Příloha byla odebrána.",
            "removeFailed": "Přílohu se nepodařilo odebrat.",
            "downloadFailed": "Přílohu se nepodařilo stáhnout."
        },
        "dropzone": {
            "idle": "Přetáhněte soubory sem nebo klepněte pro výběr",
            "dragging": "Pusťte soubory sem",
            "duplicateOrLimit": "Vybrané soubory už jsou přiložené, nebo byl dosažen limit.",
            "pickFailed": "Soubory se nepodařilo vybrat. Zkuste to prosím znovu."
        }
    },
    "profile": {
        "roles": {
            "parent": "Rodič",
            "parentPlural": "Rodiče",
            "student": "Student",
            "studentPlural": "Studenti",
            "other": "Ostatní",
            "otherPlural": "Ostatní"
        },
        "fields": {
            "first_name": "Jméno",
            "last_name": "Příjmení",
            "email": "E-mail",
            "phone": "Telefon",
            "campusLevelClass": "Kampus, stupeň a třída"
        },
        "fieldDescriptions": {
            "livingWithParent": "Uveďte, zda s vámi toto dítě primárně bydlí. Škola tyto údaje používá pro evidenci domácnosti a plánování v nouzových situacích.",
            "legalCustody": "Potvrďte, zda máte k tomuto dítěti právní péči nebo opatrovnictví. Ovlivňuje to, kdo může rozhodovat a schvalovat školní aktivity.",
            "pickupPermission": "Zda jste oprávněni vyzvedávat toto dítě ze školy. Studenty mohou vyzvedávat pouze kontakty s oprávněním.",
            "citizenshipStatus": "Status pobytu nebo občanství studenta v České republice. Škola tyto údaje potřebuje pro administrativu a oficiální hlášení.",
            "allergies": "Vyberte všechny alergie, které se na tohoto studenta vztahují. Pokud žádné známé alergie nejsou, zvolte Žádné. Personál tyto údaje používá při stravování a první pomoci.",
            "dietaryRestrictions": "Vyberte případná dietní omezení pro školní stravování a akce. Pokud žádná omezení nejsou, zvolte Žádné.",
            "healthInsuranceCompany": "Zdravotní pojišťovna, u které je student pojištěn. Používá se při školních výletech a zdravotních urgencích.",
            "primaryContact": "Vyberte, který rodič je hlavním kontaktem pro tohoto studenta.",
            "invoiceRecipient": "Vyberte, kterému rodiči mají být zasílány faktury za tohoto studenta.",
            "pickupPermissionDays": "Vyberte dny v týdnu, kdy smí tento student odcházet ze školy sám bez vyzvednutí dospělým."
        },
        "groups": {
            "contact": "Kontakt",
            "familyPickup": "Rodina a vyzvedávání",
            "billing": "Fakturace",
            "student": "Student",
            "school": "Škola",
            "medical": "Zdravotní data",
            "familyPermissions": "Rodina a oprávnění"
        },
        "familyProfiles": "Rodinné profily",
        "familyProfilesEmptyFooter": "Zatím nejsou propojeny žádné rodinné profily. Pokud má být účet propojen, kontaktujte školu.",
        "loadingProfiles": "Načítání profilů…",
        "error": {
            "noProfiles": "Žádné profily nenalezeny.",
            "invalidProfileSelected": "Vybrán neplatný profil.",
            "tryAgain": "Zkusit znovu",
            "failedToLoadProfile": "Nepodařilo se načíst profil."
        },
        "placeholder": "Profil",
        "saveChanges": "Uložit změny",
        "savedTitle": "Změny uloženy",
        "savedBody": "Změny v profilu byly uloženy.",
        "unsavedChangesTitle": "Zahodit změny?",
        "unsavedChangesMessage": "Máte neuložené změny. Pokud teď odejdete, budou ztraceny.",
        "unsavedChangesKeepEditing": "Pokračovat v úpravách",
        "unsavedChangesDiscard": "Zahodit",
        "badge": {
            "you": "Vy",
            "other": "Jiné",
            "parent": "Rodič",
            "student": "Student"
        },
        "saveFailed": "Uložení profilu se nezdařilo.",
        "title": {
            "parentProfile": "Profil rodiče",
            "otherProfile": "Profil ostatní",
            "studentProfile": "Profil studenta",
            "description": {
                "parent": "Kontrolujte a aktualizujte své kontaktní údaje a školní údaje.",
                "student": "Kontrolujte a aktualizujte údaje tohoto studenta a školní údaje.",
                "other": "Kontrolujte a aktualizujte údaje tohoto kontaktu."
            },
            "descriptionReadOnly": {
                "parent": "Tento profil může upravit jen daný rodič. Informace níže si můžete prohlédnout.",
                "student": "Jen rodič hlavního kontaktu může upravovat tento profil. Můžete kontrolovat informace níže."
            }
        }
    },
    "ui": {
        "selectOptions": "Vyberte možnosti",
        "selectOneOption": "Vyberte jednu možnost",
        "selectOptionsMore": "{{visible}} +{{count}} dalších",
        "selectDate": "Vyberte datum",
        "closeDatePicker": "Zavřít výběr datumu",
        "selectTime": "Vyberte čas",
        "closeTimePicker": "Zavřít výběr času",
        "cancel": "Zrušit",
        "done": "Hotovo",
        "selectOneOrMoreOptions": "Vyberte jednu nebo více možností",
        "selectStudent": "Pro pokračování vyberte alespoň jednoho studenta",
        "repeat": "Opakovat",
        "oneOff": "Nikdy",
        "daily": "Každý den",
        "recurring": "Každý týden",
        "daysOfWeek": "Dny v týdnu",
        "weekdayShort": {
            "1": "Po",
            "2": "Út",
            "3": "St",
            "4": "Čt",
            "5": "Pá",
            "6": "So",
            "7": "Ne"
        },
        "weekday": {
            "1": "pondělí",
            "2": "úterý",
            "3": "středa",
            "4": "čtvrtek",
            "5": "pátek"
        },
        "optional": "Nepovinné"
    },
    "absences": {
        "subtitle": "Zkontrolujte aktuální omluvenky pro studenta.",
        "currentTitle": "Aktuální omluvenky",
        "currentDescription": "Omluvenky vyžadující pozornost a schválené omluvenky, které právě probíhají nebo brzy začnou.",
        "newRequest": "Nová omluvenka",
        "currentEmptyTitle": "Žádné aktuální omluvenky",
        "currentEmptyDescription": "Vytvořte omluvenku, když potřebujete nahlásit nebo naplánovat absenci."
    },
    "pickups": {
        "subtitle": "Spravujte vyzvedávání studenta. Rodiče a zástupci jsou oprávněni vyzvedávat studenta i bez žádosti o vyzvednutí.",
        "currentTitle": "Nadcházející vyzvednutí",
        "newRequest": "Nová žádost o vyzvednutí",
        "currentEmptyTitle": "Žádná nadcházející vyzvednutí",
        "currentEmptyDescription": "Vytvořte žádost o vyzvednutí, když studenta ze školy vyzvedne někdo jiný.",
        "leaveDaysTitle": "Dny bez vyzvedávání",
        "leaveDays": "Odchází sám/sama",
        "leaveDaysUnavailable": "Dny bez vyzvedávání pro tohoto studenta nejsou k dispozici.",
        "pickupRequired": "Vyžaduje se vyzvednutí"
    },
    "whatsNew": {
        "title": "Pár věcí, které vám to usnadní",
        "continue": "Pokračovat",
        "items": {
            "recurring": "Nastavení omluvenek a vyzvednutí jako opakované, když jde o pravidelné dny.",
            "times": "Upřesnění času u omluvenky, pokud absence není na celý den.",
            "replies": "Přidání odpovědi nebo přílohy k omluvence, když škola potřebuje doplnit informace."
        }
    },
    "forceUpdate": {
        "title": "Je tu nová verze",
        "body": "Je k dispozici nová verze aplikace, kterou potřebujete, aby vše fungovalo správně. Aktualizujte ji prosím {{store}}.",
        "update": "Aktualizovat {{store}}",
        "storeAppStore": "v App Store",
        "storeGooglePlay": "na Google Play"
    }
}
